/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import type Mithril from 'mithril';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelfArticleCountAttrs extends ComponentAttrs {
	bookshelf: Bookshelf;
}

export default class BookshelfArticleCount<
	CustomAttrs extends BookshelfArticleCountAttrs = BookshelfArticleCountAttrs,
> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf } = this.attrs;

		return (
			<span className="BookshelfArticleCount">
				<b>{bookshelf.articleCount()}</b>{' '}
				{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelf.books', { books: bookshelf.articleCount() })}
			</span>
		);
	}
}
